import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Table } from 'react-bootstrap';
import PropTypes from "prop-types";
import InputSelect from '../../../../../components/modalComponents/InputSelect';
import InputText from '../../../../../components/modalComponents/InputText';
import GenericModal from '../../../../../components/modal/GenericModal';
import {CustomModalFooter, PrimaryActionButtonForModal} from '../../../styledComponents/styledComponents';
import { useManagePostRequest } from '../../../../../hooks/useManagePostRequest/useManagePostRequest';
import { cuadroRequerimientosEditarMetaComercialCampanaAPI, cuadroRequerimientosGetDataToCreateMetaComercialCampanaAPI, cuadroRequerimientosRegistrarMetaComercialCampanaAPI } from '../../../../../consumers/backendApisUrls';

const Styles = styled.div`
  .modal-body {
      padding: 20px;
  }

  .table-container {
    display: block;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    height: 40vh;
    border: 1px solid #dee2e6;
  }

  .custom-table {
    table-layout: fixed;
    text-align: center;
    width: 100%;
    margin-bottom: 0;
    
    th {
      vertical-align: middle;
      color: #333;
      white-space: nowrap;
      position: sticky;
      top: 0;
      background-color: #fff;
    }

    .bg-orange { background-color: #ffccbc !important; }
    .bg-blue { background-color: #b3e5fc !important; }
    .bg-green { background-color: #c8e6c9 !important; }
    
    td {
        vertical-align: middle !important;
        border: 1px solid #dee2e6;
    }
  }

  @media (max-width: 1000px) {
    .table {
      display: block;
    }
    .egssth .description {
      border: 0 !important;
    }
  }
`;



const AgregaMetaSedeModal = ({ showModal, title, mode, data, campana, listSedes, refetchData }) => {

    const [executeManagePostRequest] = useManagePostRequest();

    const [dataMetaSedeModal, setDataMetaSedeModal] = useState([]);

    const colors = {
        'B': 'bg-orange',
        'BE': 'bg-orange',
        'PK': 'bg-orange',
        'K': 'bg-orange',
        '1': 'bg-blue',
        '2': 'bg-blue',
        '3': 'bg-blue',
        '4': 'bg-green',
        '5': 'bg-green',
        '6': 'bg-green',
        '7': 'bg-green',
        '8': 'bg-green',
        '9': 'bg-green',
        '10': 'bg-green',
        '11': 'bg-green',
    };

    const [selectedSede, setSelectedSede] = useState(null);
    const [numAlumnos, setNumAlumnos] = useState('');
    const [totalSecciones, setTotalSecciones] = useState(0);

    const handleChangeAlumnos = (val) => {
        if (val === '' || /^\d+$/.test(val)) {
            setNumAlumnos(val);
        }
    };

    const handleChangeSede = async (e) => {
        setSelectedSede(e);
        const payload = {
            IdCampana: campana.IdCampana,
            IdSede: e.value
        };
        await executeManagePostRequest(
            cuadroRequerimientosGetDataToCreateMetaComercialCampanaAPI(),
            payload,
            async (res) => {
                const data = await res?.data?.Items ?? [];
                const initializedData = data.map(item => ({
                    ...item,
                    NroSecciones: item.NroSecciones ?? '0'
                }));
                setDataMetaSedeModal(initializedData);
            },
            false
        );
    };

    const handleGridChange = (idx, val) => {
        const newData = [...dataMetaSedeModal];
        newData[idx].NroSecciones = val;
        setDataMetaSedeModal(newData);
    };

    const EditableCell = ({ value, onChange }) => {

        const handleChange = (e) => {
            const val = e.target.value;
            if (/^\d*$/.test(val)) {
                if (val.length > 1 && val.startsWith('0')) {
                    onChange(val.substring(1));
                } else {
                    onChange(val);
                }
            }
        };

        return (
            <input
                type="text"
                className="form-control"
                defaultValue={value}
                onChange={() => {}}
                onBlur={handleChange}
                onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
                maxLength={2}
                style={{
                    width: '100%',
                    height: '100%',
                    minWidth: 0,
                    textAlign: 'center',
                    padding: 0,
                    margin: 0,
                    fontFamily: 'inherit',
                    fontSize: 'inherit',
                    color: 'inherit'
                }}
            />)

    };

    const handelSaveMetaSede = async () => {
        if (mode) {
            const payload = {
                IdMetaComercialCampana: data?.IdMetaComercialCampana ?? 0,
                IdCampana: campana?.IdCampana ?? 0,
                IdSede: selectedSede?.value ?? 0,
                NroAlumnos: numAlumnos ?? 0,
                Items: (dataMetaSedeModal ?? []).map(item => ({
                    IdGrado: item.IdGrado ?? 0,
                    IdNivel: item.IdNivel ?? 0,
                    NroSecciones: item.NroSecciones ?? 0
                }))
            };
            await executeManagePostRequest(
                cuadroRequerimientosEditarMetaComercialCampanaAPI(),
                payload,
                (res) => {
                    refetchData();
                    showModal();
                },
                true,
                (err) => { console.log(err); },
                true
            );
        } else {
            const payload = {
                IdCampana: campana?.IdCampana ?? 0,
                IdSede: selectedSede?.value ?? 0,
                NroAlumnos: numAlumnos ?? 0,
                Items: (dataMetaSedeModal ?? []).map(item => ({
                    IdGrado: item.IdGrado ?? 0,
                    IdNivel: item.IdNivel ?? 0,
                    NroSecciones: item.NroSecciones ?? 0
                }))
            };
            await executeManagePostRequest(
                cuadroRequerimientosRegistrarMetaComercialCampanaAPI(),
                payload,
                (res) => {
                    refetchData();
                    showModal();
                },
                true,
                (err) => { console.log(err); },
                true
            );
        }
    };

    useEffect(() => {
        if (mode && data) {
            const formatDataSede = [{
                value: data?.IdSede ?? 0,
                label: data?.Sede ?? ''
            }];
            const sede = listSedes.filter(s => formatDataSede.some(f => f.value === s.value));
            if (sede) setSelectedSede(sede);
            setNumAlumnos(data?.NroAlumnos ?? 0);
            setDataMetaSedeModal(data?.Items ?? []);
        } else {
            setSelectedSede(null);
            setNumAlumnos(0);
            setDataMetaSedeModal([]);
        }
    }, [mode, data, listSedes]);

    useEffect(() => {
        const total = dataMetaSedeModal.reduce((acc, curr) => acc + (parseInt(curr.NroSecciones) || 0), 0);
        setTotalSecciones(total);
    }, [dataMetaSedeModal]);

    return (
        <GenericModal
            showModal={showModal}
            width="500px"
            titulo={title}
        >
            <Styles>
                <div className="modal-body">
                    <Row className="mb-3">
                        <Col md={12}>
                            <InputSelect
                                label="Sede:"
                                options={listSedes}
                                value={selectedSede}
                                onChange={async (e) => handleChangeSede(e.target.value)}
                                name="sede"
                                direction="row"
                                isDisabled={mode}
                            />
                        </Col>
                        <Col md={12}>
                            <InputText
                                label="# Alumnos:"
                                value={numAlumnos}
                                name='numAlumnos'
                                onChange={(e) => handleChangeAlumnos(e.target.value)}
                                direction="row"
                            />
                        </Col>
                    </Row>

                    <div className="table-container">
                        <Table bordered hover size="sm" className="custom-table">
                            <thead className='listar-thead'>
                                <tr>
                                    <th style={{ width: '40px' }}>
                                        <div className='flex font-gothan-medium'>Grado</div></th>
                                    <th style={{ width: '100px' }}>
                                        <div className='flex font-gothan-medium'>Nivel</div></th>
                                    <th style={{ width: '60px' }}>
                                        <div className='flex font-gothan-medium'># Sección</div></th>
                                </tr>
                            </thead>
                            <tbody className='listar-tbody'>
                                {dataMetaSedeModal.length > 0 && (
                                    (dataMetaSedeModal ?? []).map((row, idx) => (
                                        <tr key={idx}>
                                            <td className={`text-left ${colors[row?.Grado ?? '']}`}>{row?.Grado}</td>
                                            <td>{row?.Nivel ?? ''}</td>
                                            <td>
                                                <EditableCell
                                                    value={row?.NroSecciones}
                                                    onChange={(val) => handleGridChange(idx, val)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                                {dataMetaSedeModal.length > 0 && (
                                    <tr style={{ fontWeight: 'bold' }}>
                                        <td colSpan={2} className="text-right">Total</td>
                                        <td>{totalSecciones}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <CustomModalFooter>
                    <PrimaryActionButtonForModal onClick={handelSaveMetaSede}>
                        Guardar
                    </PrimaryActionButtonForModal>
                </CustomModalFooter>
            </Styles>
        </GenericModal>
    );
};

AgregaMetaSedeModal.propTypes = {
    showModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    mode: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
    campana: PropTypes.object.isRequired,
    listSedes: PropTypes.array.isRequired,
    refetchData: PropTypes.func.isRequired
};

export default AgregaMetaSedeModal;
